var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from "vue-facing-decorator";
import { ConnectivityTestLookupStatus, ConnectivityTestMatchedOn, GetConnectivityTestByIdentifierQuery, SystemCommunicationsClient } from "@/app/api/battery-portal-api";
import { HttpHelper } from "@/app/utils/http-helper";
import { Notifier } from "@/common/utils/notifier";
import moment from "moment";
const systemCommunicationsClient = new SystemCommunicationsClient(window.apiUrl);
/// Mirrors GetConnectivityTestByIdentifierQuery.MIN_IDENTIFIER_LENGTH. The backend is the
/// authority - it returns Invalid regardless of what is typed here - this only shapes the message.
const MIN_IDENTIFIER_LENGTH = 4;
let ConnectivityTestModal = class ConnectivityTestModal extends Vue {
    constructor() {
        super(...arguments);
        this.isVisible = false;
        this.working = false;
        this.checked = false;
        this.identifier = "";
        this.status = ConnectivityTestLookupStatus.Invalid;
        this.matchedOn = null;
        this.results = [];
        // Exposed for the template, which cannot reference module scope directly.
        this.LookupStatus = ConnectivityTestLookupStatus;
        this.minimumLength = MIN_IDENTIFIER_LENGTH;
    }
    show() {
        this.isVisible = true;
        this.reset();
    }
    get code() {
        return this.results.length ? this.results[0].code || "" : "";
    }
    get processedAt() {
        return this.results.length ? this.results[0].processedAt : null;
    }
    get controllerCreatedAt() {
        var _a;
        return this.results.length ? (_a = this.results[0].controllerCreatedAt) !== null && _a !== void 0 ? _a : null : null;
    }
    /// Naming the field that matched matters most when the user searched by name, where several
    /// Controllers could plausibly have answered.
    get matchedOnText() {
        switch (this.matchedOn) {
            case ConnectivityTestMatchedOn.Code: return "";
            case ConnectivityTestMatchedOn.SerialNumber: return ", matched on serial number";
            case ConnectivityTestMatchedOn.ControllerName: return ", matched on Controller name";
            default: return "";
        }
    }
    check() {
        if (this.working)
            return;
        this.working = true;
        systemCommunicationsClient
            .checkConnectivityTest(new GetConnectivityTestByIdentifierQuery({ identifier: this.identifier }))
            .then(response => {
            var _a;
            if (!response)
                return;
            this.status = response.status;
            this.matchedOn = (_a = response.matchedOn) !== null && _a !== void 0 ? _a : null;
            this.results = response.results || [];
            this.checked = true;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    formatDate(value) {
        return value ? moment(value).format("DD/MM/YYYY HH:mm:ss") : "-";
    }
    onHidden() {
        this.reset();
    }
    reset() {
        this.identifier = "";
        this.status = ConnectivityTestLookupStatus.Invalid;
        this.matchedOn = null;
        this.results = [];
        this.checked = false;
        this.working = false;
    }
};
ConnectivityTestModal = __decorate([
    Component({
        name: "ConnectivityTestModal"
    })
], ConnectivityTestModal);
export default ConnectivityTestModal;
